function CheckboxBool({ id, label, value, onChange }) {
    // const [selected, setSelected] = useState(value);

    // const handleChange = function (e) {
    //     const { value, checked } = e.target;
    //     setSelected(checked ? 1 : 0);
    // };

    // useEffect(() => {
    //     // retourner les valeurs dans le callback du parent
    //     setReturnValues(selected);
    // }, [selected]);

    return (
        <div class="form-floating mb-3">
            {/* onChange={handleChange} */}
            <div class="form-control">
                <input class="form-check-input" type="checkbox" id={id} name={id} value="true" checked={value == 1 || value === true } onChange={onChange} />
            </div>
            <label class="form-label" for={id}>
                {label}
            </label>
        </div>
    )
}

export default CheckboxBool;